import { useNavigate } from "react-router-dom";
import '../../css/Banner.css';

import BannerImage from "../../../assets/banner.webp";
import Link from "../../../assets/links.png";


export default function Banner({ setGetTestOps }) {
  const navigate = useNavigate();

  function TryTestOps() {
    setGetTestOps(true);
  }

  return (
    <section className="banner-section">
      <div>
        <div className="row align-items-center">

          {/* Image Section */}
          <div className="col-md-7 order-1 order-md-2 banner-image">
            <img
              src={BannerImage}
              alt="banner"
              className="img-fluid"
            />
          </div>

          {/* Content Section */}
          <div className="col-md-5 order-2 order-md-1 banner-content">
            <h1 className="banner-title">
              Streamline Your quality assurance <br />
              With <br />
              <span>Froth TestOps</span>
            </h1>

            <p className="banner-text">
              Froth TestOps unifies manual and automated testing with seamless
              monitoring, multi-source results, CI integration, rapid issue
              reporting, and AI-assisted requirements, test case management, and
              scheduling—enhancing transparency, team effectiveness, and overall
              software testing lifecycle performance as a{" "}
              <span>top test management tools</span>.
            </p>

            {/* <button className="banner-btn" onClick={TryTestOps}>
              Try It For No Cost
              <img
                src={Link}
                alt="icon"
                className="ms-2"
                width="16"
              />
            </button> */}
          </div>

        </div>
      </div>
    </section>
  );
}